var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontpage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 4.66681,
    height: 4.66681,
    rx: 2.3334,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 14.8896,
    width: 4.66681,
    height: 4.66681,
    rx: 2.3334,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.334,
    y: 4,
    width: 4.66681,
    height: 4.66681,
    rx: 2.3334,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.334,
    y: 14.8896,
    width: 4.66681,
    height: 4.66681,
    rx: 2.3334,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontpage);
export default __webpack_public_path__ + "static/media/frontpage.f020cc1f612ddc3ef731119bb1184924.svg";
export { ForwardRef as ReactComponent };